import LoginCtrl from './login.controller';
import template from './login.html';
import './login.scss';

export default {
	template,
	controller: LoginCtrl,
	controllerAs: '$ctrl',
	path: '/login',
	reloadOnUrl: false,
	showHeader: false,
};
